var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,35H61V32a1,1,0,0,0-1-1H59V20a3,3,0,0,0-3-3H42a3,3,0,0,0-3,3V31H38a1,1,0,0,0-1,1v3H35V26a1,1,0,0,0-1-1H26a1,1,0,0,0-1,1v1H24a3,3,0,0,0,0,6h1v2H15V32a1,1,0,0,0-1-1H13V28a1,1,0,0,0-1-1H2a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H3v2H2a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H5V62a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V61H51v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V43h3a1,1,0,0,0,1-1V36A1,1,0,0,0,62,35ZM41,20a1,1,0,0,1,1-1H56a1,1,0,0,1,1,1V31H41ZM39,33H59v2H39ZM24,31a1,1,0,0,1,0-2h1v2Zm3-4h6v8H27ZM3,29h8v2H3Zm2,4h8v2H5ZM7,61V43h4V61Zm6-2V43H51V59Zm44,2H53V43h4Zm4-20H3V37H61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,21a4,4,0,1,0,4,4A4,4,0,0,0,49,21Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,49,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59,19a1.42,1.42,0,0,1,0,2l-1.3,1.29,1.42,1.42L29,22.41a3.4,3.4,0,0,0,0-4.82L28.41,17A1.43,1.43,0,0,1,28,16V15H26v1a3.36,3.36,0,0,0,1,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.59,19a1.42,1.42,0,0,1,0,2l-1.3,1.29,1.42,1.42L33,22.41a3.4,3.4,0,0,0,0-4.82L32.41,17A1.43,1.43,0,0,1,32,16V15H30v1a3.36,3.36,0,0,0,1,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23A11,11,0,1,0,1,12,11,11,0,0,0,12,23ZM5,6.39,6.29,7.71,7.71,6.29,6.39,5A8.89,8.89,0,0,1,11,3.06V5h2V3.06A8.89,8.89,0,0,1,17.61,5L16.29,6.29l1.42,1.42L19,6.39A8.89,8.89,0,0,1,20.94,11H19v2h1.94A8.89,8.89,0,0,1,19,17.61l-1.31-1.32-1.42,1.42L17.61,19A8.89,8.89,0,0,1,13,20.94V19H11v1.94A8.89,8.89,0,0,1,6.39,19l1.32-1.31L6.29,16.29,5,17.61A8.89,8.89,0,0,1,3.06,13H5V11H3.06A8.89,8.89,0,0,1,5,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.29,16.71l1.42-1.42L13,11.59V7H11v5a1,1,0,0,0,.29.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/Office.17b0d02b.svg";
export { ForwardRef as ReactComponent };